import {
  Grid,
  Container,
  CssBaseline,
  Typography,
  Box
} from '@material-ui/core';
import Button from '../../components/button/index';
import { useStyles } from "../Login/styles";
import { axiosHelper } from 'utils/axios';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
const { MOMMYVUE_API_URL } = (window as any).env
const SignupPaymentPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [showPayPalOptions, setShowPayPalOptions] = useState(false);
  const [orderIDPayPal, setOrderIDPayPal] = useState(false);
  const [successPayPal, setSuccessPayPal] = useState(false);
  const [ErrorMessagePayPal, setErrorMessagePayPal] = useState("");

  const createSession = () => {
    axiosHelper.post(`${MOMMYVUE_API_URL}/Subscription/create-checkout-session`, {
      lookup_key: 'price_1Ki0SkSGDeSkSR3eO1kkhKwC'
    }).then((response) => {
      window.location.href = response.data.sessionURL;
    });
  }
  //Paypal Actions
  useEffect(() => {
    if (successPayPal) {
      history.push("/sucess-stripe-payment")
    }
  },
    [history, successPayPal]
  );

  console.log(1, orderIDPayPal);
  console.log(2, successPayPal);
  console.log(3, ErrorMessagePayPal);
  // creates a paypal order
  const createOrder = (data: any, actions: any) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "MommyVue Package Subscription",
            amount: {
              currency_code: "USD",
              value: 1,
            },
          },
        ],
        // not needed if a shipping address is actually needed
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID: string) => {
        setOrderIDPayPal(orderIDPayPal);
        return orderID;
      });
  };

  // check Approval
  const onApprove = (data: any, actions: any) => {
    return actions.order.capture().then(function (details: any) {
      const { payer } = details;
      console.log(payer);
      setSuccessPayPal(true);
    });
  };
  //capture likely error
  const onError = (err: any) => {
    setErrorMessagePayPal("An Error occured with your payment ");
  };
  //capture likely error
  const onCancel = (data: any, actions: any) => {
    history.push("/cancel-stripe-payment");
    setErrorMessagePayPal("An Error occured with your payment ");
  };
  return (
    <Container component="main" className={classes.loginWrapper}>
      <CssBaseline />
      <Grid xs={4} className={classes.accountCreatedWrapper}>
        <Grid className={classes.verificationMessage}>
          <Typography component="h1" variant="h5" className={classes.accountCreatedHeader}>
            Complete Signup
          </Typography>
          <Typography component="p" className={classes.paymentDescription}>
            Your account is almost setup. To complete your setup you will be redirected to our payment service to subscribe to our product.
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ paddingTop: 25 }}
          >
            <Button text="Click here to finish payment via Stripe" action={() => createSession()} />
          </Grid>

          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ paddingTop: 25 }}
          >
            {!showPayPalOptions && <Button text="Click here to finish payment via PayPal" action={() => setShowPayPalOptions(true)} />}
            <Box>
              <PayPalScriptProvider
                options={{
                  "client-id": "AdF8zQBLEv4NIunjF2j_vvxr6oBh8-M3xmZSrjSBhpalA1aI0C9Q85kv4MMzDqeBcEUM_vI7iPYsmnC9",
                }}
              >
                {showPayPalOptions ? (
                  <PayPalButtons
                    style={{ layout: "vertical" }}
                    createOrder={createOrder}
                    onApprove={onApprove}
                    onError={onError}
                    onCancel={onCancel}
                  />
                ) : null}
              </PayPalScriptProvider>
            </Box>
          </Grid>
          <Typography component="p" className={classes.paymentDisclaimer}>
            By completing your subcription you agree to the terms and conditions stated <a href="#terms">here</a>.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

export default SignupPaymentPage;